export * from './index';



//////////////////
// WEBPACK FOOTER
// ./~/ng2-translate/ng2-translate.js
// module id = 1048
// module chunks = 3